import costCenterService from '@/api/costcenter'

export default {
  namespaced: true,
  actions: {
    // eslint-disable-next-line no-empty-pattern
    searchCostCenter({}, {query}) {
      return new Promise((resolve) => {
        if (query.length === 1 || !query || query.match('(  )')) {
          resolve([])
        } else {
          costCenterService.searchCostCenter(query).then((response) => {
            resolve(response.data)
          }).catch(() => {
            resolve([])
          })
        }
      })
    },
  }
}

